import { render, staticRenderFns } from "./reviewReportComponent.vue?vue&type=template&id=a7437ab2&scoped=true"
import script from "./reviewReportComponent.vue?vue&type=script&lang=js"
export * from "./reviewReportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7437ab2",
  null
  
)

export default component.exports